var _slicedToArray = require("/codebuild/output/src039361128/src/rottay-website/node_modules/@babel/runtime/helpers/slicedToArray.js");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = e || self)["react-hooks-visible"] = {}, e.React);
}(this, function (e, t) {
  "use strict";

  function r() {
    return (r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }).apply(this, arguments);
  }
  var n = {
    root: null,
    rootMargin: "0px",
    threshold: Array.from({
      length: 100
    }, function (e, t) {
      return .01 * t;
    })
  };
  e.useVisible = function (e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var u = t.useRef(null),
      c = t.useRef(null),
      _t$useState = t.useState(0),
      _t$useState2 = _slicedToArray(_t$useState, 2),
      s = _t$useState2[0],
      i = _t$useState2[1],
      f = "function" == typeof e ? e(s) : s,
      a = t.useCallback(function (e) {
        e.forEach(function (e) {
          i(e.intersectionRatio);
        });
      }, []);
    return t.useEffect(function () {
      c.current || u.current && (c.current = new IntersectionObserver(a, r({}, n, {}, o)), c.current.observe(u.current));
    }), [u, f];
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});